<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
        <el-form :model="queryParams" ref="queryForm" :inline="true">
            <el-form-item label="监督对象:" prop="name">
                <el-input
                v-model="queryParams.name"
                placeholder="请输入监督对象"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="上传日期:" prop="zylb">
                <el-date-picker size="small" clearable
                    v-model="queryParams.startDate"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
                至
                <el-date-picker size="small" clearable
                    v-model="queryParams.endDate"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                <el-button
                type="danger"
                icon="el-icon-plus"
                size="small"
                @click="handleAdd"
                >新增案卷</el-button>
            </el-form-item>
        </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
        <el-table v-loading="loading" :data="chackcaseList">
            <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                </template>
            </el-table-column>
            <el-table-column label="监督对象名称" prop="dwmc" width="200" />
            <el-table-column label="上传日期" align="center" prop="creattime" >
                <template slot-scope="scope">
                    <span v-if="scope.row.creattime">{{ getDate2(scope.row.creattime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="评查状态" align="center" prop="shifoupingcha" >
                <template slot-scope="scope">
                    <span v-if="scope.row.shifoupingcha == 1"><i style="width: 8px; height: 8px; display: inline-block; background: #1890ff; border-radius: 4px; margin-right: 5px;"></i>已评查</span>
                    <span v-else><i style="width: 8px; height: 8px; display: inline-block; background: #ff4a4a; border-radius: 4px; margin-right: 5px;"></i>未评查</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="140" >
                <template slot-scope="scope">
                <el-button v-if="scope.row.states != 1"
                    size="small"
                    type="text"
                    @click="handleUpdate(scope.row)"
                >{{scope.row.shifoupingcha == 1 ? '查看':'评查'}}</el-button>
                <el-button 
                    size="small"
                    type="text"
                    @click="handleDelete(scope.row.lsh)"
                >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-part" style="padding:20px 20px 50px;">
            <el-pagination  v-if="pageshow"
                background
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page.sync="queryParams.page"
                :page-sizes="[10,20,30,40]"
                :page-size="queryParams.limit"
                layout="total, prev, pager, next, jumper"
                :total="total" style=" float:right;">
            </el-pagination>
        </div>
            </div>
        </el-card>

        <!-- 添加或修改用户对话框 -->
        <el-dialog title="上传案件" :visible.sync="openAj" top="20vh" width="600px" append-to-body :close-on-click-modal="false" class="newTk">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="shangchuan">
                    <el-form-item label="案卷:">
                        <el-upload ref="upload"
                            class="upload-demo"
                            drag              :before-remove="handleRemove"          
                            action="#"  :before-upload="beforeUpload"
                            multiple :file-list="fileList" accept=".pdf,image/*">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">
                            支持1个pdf或多个image/*格式文件上传<br/>
                            说明：扫描件300dpi以下，仅支持竖版，大小50mb以内
                            </div>
                        </el-upload>
                        <p style="color: #ff0000;">{{errText}}</p>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitAj">识别案卷</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="案中评查解析" :visible.sync="open" top="8vh" width="85%" append-to-body class="newTk" :close-on-click-modal="false">
            <div class="nr">
                <p class="beizhu">注:系统智能识别后，部分文书未能智能识别，需进行人工识别。</p>
                <div class="cay" style="float:right;text-align: right;margin-top:-20px;" >
                    <el-button type="success" size="small"  v-if="row && row.states != 1" @click="getPingcha(row)">评查</el-button>
                </div>
                <div class="shibieW">
                    <div class="imgs left2">
                        <div class="imgW" v-loading="loading3">
                            <el-scrollbar ref="myScrollbar2">
                                <p v-show="sbSrcs" v-for="(item,index) in sbSrcs" :key="index">
                                    <img :src="item.httpsUrl" @dblclick="showBig(item.httpsUrl)" />
                                    <span>第&nbsp;{{index + 1}}&nbsp;页</span>
                                </p>
                            </el-scrollbar>
                        </div>
                    </div>
                    <div class="right2">
                        <h3 style="    padding: 10px 0;">解析描述</h3>
                        <div style="    height: calc(100% - 40px);">
                            <el-form v-loading="loading4" ref="form" :model="form" :rules="rules" label-width="0" style="height:100%;">
                                <el-form-item label="">
                                    <el-input type="textarea" v-model="jxnr" style="height:calc(67vh - 40px);"></el-input> 
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    
                </div>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="案卷识别文书" :visible.sync="open2" top="20px" :width="isH?'700px':'1200px'" append-to-body ref="rotate"  :close-on-click-modal="false">
            <div style="text-align: right;
    margin-right: 40px;
    position: absolute;
    right: 10px;
    top: 8px;"><el-button type="warning" size="small" @click="rotate">旋转</el-button></div>
            <p v-show="bigSrcs" v-for="(item,index) in bigSrcs" :key="index" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;">
                <img :src="item" style="width: 100%;" />
            </p>
            <p v-show="bigSrc" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;"><img :src="bigSrc"  style="width: 100%;" /></p>
        </el-dialog>
        <div v-show="open4" class="tzbox" style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.5); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div style="width:800px; position: relative; z-index: 9999;top: 10vh; left: 50%; margin-left: -300px;height: auto;box-shadow: 0 1px 3px rgb(0 0 0 / 30%);">
                <vue-drag-resize :isActive="isActive" :isResizable="false" :preventActiveBehavior="true">
                    <h3 style="background: #e6e6e6;font-weight: normal; padding: 0px 20px 0px; line-height: 48px; border-radius: 4px 4px 0 0;">已识别内容
                    <i class="el-icon el-icon-close" @click="open4 = false" style="color: #909399;float:right;font-size:16px;margin-top: 18px;cursor: pointer;"></i></h3>
                    <div style="width:100%; background:#fff;padding:20px 0px 0; overflow: hidden;">
                        <label style="color:#ff0000; float:left; margin:0 10px 0 45px; font-weight: bold;">* 双击已识别文字{{isActive?'关闭':'开启'}}拖拽</label>
                        <el-switch v-model="isActive" active-text=""></el-switch></div>
                    <p  @dblclick="beginTz()" style="padding:15px 45px 40px;line-height:30px;font-size:15px;text-indent: 2rem;font-weight: bold; background: #fff; border-radius: 0 0 4px 4px;">{{ contentL }}</p>
                </vue-drag-resize>
            </div>
        </div>
        <div v-show="loading2"  style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.05); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div class="load" style="position: absolute;padding-top: 40px; z-index: 2;    background: linear-gradient(128deg, rgb(255, 255, 255) 40%, rgb(230, 240, 252)); width: 700px; height: 400px; border-radius: 4px; top: 18vh; left: 50%;  margin-left: -350px;  text-align: center;">
                <img style="margin: 30px auto 30px;" src="../../../assets/images/loading.png" />
                <p style="font-weight: bold; font-size: 18px;">案卷正在上传解析中，预计需要1~5分钟,请不要关闭页面...</p>
            </div>
        </div>
    </div>
</template>

<script> 
import VueDragResize from 'vue-drag-resize';
import Ajxq from '../ajpc/ajxq.vue'
import Znpc from '../ajpc/znpc.vue'
import axios from 'axios'
import qs from 'qs'

import pdfShow from './pdfShow.vue'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            loading2:false,
            loading3:false,
            loading4:false,
            cmid:'',
            dm:'',
            xianqu:'',
            queryParams:{
                name:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
                shi:'',
                xianqu:'',
                isPingce:''
            },
            times:[],
            times2:[],
            total:0,
            chackcaseList:[],
            form:{},
            open: false,
            openAj: false,
            tpbase:'',
            fileName:'',
            files:{},
            filesL:[],
            sbFile:'',
            sbSrc:'',
            sbSrcs:[],
            identifyList:[],
            isIndex:0,
            identifyList2:[],
            isIndex2:0,
            bigSrc:'',
            bigSrcs:[],
            open2:false,
            fileList: [],
            pcId:'',
            rules: {
                fileName: [{ required: true, message: "资料名称不能为空", trigger: "blur" }],
                pageCount: [{ required: true, message: "资料页数不能为空", trigger: "blur" }],
            },
            projects:[],
            total:0,
            open3:false,
            content:'',
            open4:false,
            contentL:'',
            row:{},
            open5:false,
            formDw:{},
            formR:{},
            open6:false,
            restaurants: [],
            pageshow:true,
            anyou2:'',
            open7:false,
            pcId2:'',
            deg:0,
            isH:true,
            isActive:true,
            states:0,
            shiOptions:[],
            xianquOptions:[],
            sc: "",
            xg: "",
            xz: "",
            errText:'',
            jxnr:'',

            openML:false,
            loadingMl:false,
            openYz:false,
            loading3Yz:false,
            open6Yz:false,
            isJiexi:true,
            sbSrcN:'',
            sbSrcsN:[],
            mlList:[],

            pdfUrl:'',
            imageList:[],
            scFile:'',
            baseUrl:''
        }
    },
    components: {
        Ajxq,
        Znpc,
        VueDragResize,
        pdfShow
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '事中评查解析'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.xianqu = user.xianqu
        this.baseUrl = user.baseUrl
        let yy = (new Date()).getFullYear()
        let mm1=this.Time(new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate()));
        let mm = (new Date()).getMonth() + 1
        let dd = (new Date()).getDate()
        this.times = mm1
        this.times2 = yy+'-' + mm + '-' + dd
        this.$set(this.queryParams, 'startDate', this.times)
        this.$set(this.queryParams, 'endDate', this.times2)
        this.$forceUpdate()
        this.getList()
    },
    methods: {
        Time(now) {
            let year=new Date(now).getFullYear();
            let month=new Date(now).getMonth()+1;
            let date=new Date(now).getDate();
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            return year+"-"+month+"-"+date
        },
        beginTz(){
            this.isActive = !this.isActive
        },
        callback(val){
            this.open5 = false
        },
        async querySearch(queryString, cb) {
            let data = await this.$axios.get(`${this.Global._baseUrl}?act=getWslist&name=${escape(queryString)}`)
            if(data.data != -1 && data.data != ''){
                this.restaurants = data.data
                this.restaurants.forEach(item => {
                    item.value = item.mc
                })
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            }else{
                var results = []
                cb(results);
            }
        },
        createFilter(queryString) {
            return (restaurant) => {
            return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != '-1');
            };
        },
        handleSelect(item) {
            this.form.fileName = item.value
        },
        getList(){
            this.loading = true
            this.queryParams.startDate = this.queryParams.startDate ? this.queryParams.startDate : this.times
            this.queryParams.endDate = this.queryParams.endDate ? this.queryParams.endDate : this.times2
            this.queryParams.xianqu = this.queryParams.shi ? this.queryParams.xianqu : ''
            let dm = this.queryParams.shi ? '' :this.dm
            let page = this.queryParams.page
            this.chackcaseList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getAnjiannList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmc: this.queryParams.name,
                    anyou: '',
                    cmid: this.cmid,
                    startDate:this.getDate(this.queryParams.startDate,'yyyy-MM-dd') ,
                    endDate: this.getDate(this.queryParams.endDate,'yyyy-MM-dd'),
                    states: '',
                    dm: dm,
                    shi: this.queryParams.shi,
                    xianqu: this.queryParams.xianqu,
                    isPingce: '',
                    type: 2,
                    pageSize: this.queryParams.limit,
                    pageNum: this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.chackcaseList = response.data.data.list || []
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        handleAdd(){
            this.openAj = true
            this.fileList = []
            this.fileName = ""
            this.files = {}
            this.filesL = []
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.queryParams.page = 1
            this.queryParams = {
                name:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
                shi:'',
                xianqu:'',
                isPingce:''
            }
            this.getList()
        }, 
        beforeUpload(file){
            
            const validExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif'];
            const extension = file.name.split('.').pop().toLowerCase();

            if (!validExtensions.includes(extension)) {
                this.$message.warning('上传模板只能是 PDF 或图片格式（JPG、JPEG、PNG、GIF）!');
                return;
            }

            // 判断当前文件是否为 PDF 或图片
            const isPdf = extension === 'pdf';
            const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(extension);

            // 如果已存在文件
            if (this.fileList.length > 0) {
                const existingFile = this.fileList[0];
                const existingExt = existingFile.name.split('.').pop().toLowerCase();
                const existingIsPdf = existingExt === 'pdf';
                const existingIsImage = ['jpg', 'jpeg', 'png', 'gif'].includes(existingExt);

                // 若已有 PDF，禁止再上传图片或其他 PDF
                if (existingIsPdf && (isPdf || isImage)) {
                    this.$message.warning('已上传 PDF，不能再上传其他文件！');
                    return;
                }

                // 若已有图片，禁止再上传 PDF
                if (existingIsImage && isPdf ) {
                    this.$message.warning('已上传图片，不能再上传PDF文件！');
                    return;
                }
            }

            // 检查是否重复上传同名文件
            const isDuplicate = this.fileList.some(item => item.name === file.name);
            if (isDuplicate) {
                this.$message.warning('该文件已上传，请勿重复操作');
                return;
            }

            this.fileList.push({ name: file.name });
            // 1. 将文件名追加到 fileName（逗号分隔）
            this.fileName = this.fileName 
            ? `${this.fileName}, ${file.name}` 
            : file.name;

            // 2. 将文件对象存入 files 数组（关键修复点！）
            this.files = file
            this.filesL.push(file);  // 使用 push 方法追加文件
            return false // 返回false不会自动上传
        }, 
        handleRemove(file, fileList) {
            if(file.status == 'success'){
                if(this.fileList.length > 1){
                    let isy = this.fileList.findIndex(item => {
                        return item.name == file.name
                    })
                    if(isy != -1){
                        this.fileList.splice(isy,1) 
                    }
                }
            }
        },
        async submitAj(){

            this.loading2 = true
            console.log(this.fileList)
            console.log(this.files)
            console.log(this.fileName,461)
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的文件！')
                return false
            }

            let isPdfOnly = this.fileName.endsWith('.pdf');
            console.log(isPdfOnly, 470)
            let fileType = isPdfOnly ? 'pdf' : 'image';
            
            // 创建 FormData
            let fileFormData = new FormData();
            //fileFormData.append('files', this.filesL); // 支持多文件上传
            this.filesL.forEach((file, index) => {
                //fileFormData.append(`files[${index}]`, file);
                fileFormData.append('files', file);
            });
            fileFormData.append('fileName', this.fileName);
            fileFormData.append('cmid', this.cmid);
            fileFormData.append('fileType', fileType);

            
            const res = await axios.post(this.baseUrl+`/process/upload`, fileFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 3600000
            });

            if (res.data.code === 0) {
                // 始终处理为数组，不管上传的是一个还是多个文件
                this.sbFile = res.data.filenewname.map(item => item.newFileName).join(',');
                if(this.sbFile){
                    this.getPingchaS(this.sbFile);
                };
                this.openAj = false
            } else {
                this.$message.error(res.data.msg || '上传失败，请重试');
                this.loading2 = false;
            }
		},
        getPingchaS(file){
            // 提取文件名数组
            const files = file.split(',');

            // 判断是否为 PDF 类型
            const isPdf = files[0].endsWith('.pdf');

            let params = {
                cmid: this.cmid,
                type: 2
            };

            if (isPdf) {
                params.file = files[0];
                params.imageList = [];
                this.imageList = []
                this.scFile = files[0]
            } else {
                params.file = '';
                params.imageList = files;
                this.imageList = files
                this.scFile = ''
            }

            this.pcId = ''
            this.pdfUrl = ''
            this.row = {}
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/process/anZhongFileOcr`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: params
            })
            .then(res => {
                console.log(res)
                if(res.data.code == 0){
                    this.pcId = res.data.data.pcId
                    this.pdfUrl = res.data.data.pdfUrl
                    console.log(this.pcId,546)
                    let type = isPdf ? 1 : 2
                    this.getMiaoshu(this.pcId,type)
                    if(isPdf){
                        this.getImg(this.pcId)
                    }
                    
                    this.getList()
                }else{
                    this.loading2 = false
                }
            })
            .catch(error => {
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '加载失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        getMiaoshu(pcId,type,val){ 
            this.loading3 = true
            this.loading4 = true
            this.sbSrcs = []  
            this.jxnr = ''        
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/process/anZhongFileOcrList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    pcId:pcId,
                    type:type
                }
            })
            .then(res => {
                this.loading3 = false
                this.loading4 = false
                this.loading = false
                this.open = true
                this.loading2 = false
                console.log(res,590)
                if(res.data.data.content){
                    this.jxnr = res.data.data.content
                }else{
                    this.$message.error('描述信息获取失败！请重新评查！')
                }
                if(res.data.data.list){
                    let arr = res.data.data.list
                    arr.forEach(item => {
                        this.sbSrcs.push({httpsUrl:item})
                    })
                }else{
                    this.getImg(pcId)
                }
                if(res.data.data.imageList){
                    this.imageList = res.data.data.imageList
                    console.log(this.imageList, 605)
                }
                if(val){
                    this.getPingcha(this.row)
                }
            })
            .catch(error => {
                this.loading2 = false
                this.loading = false
                this.loading3 = false
                this.loading4 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '加载失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        newUpdate(){
            this.$forceUpdate();
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
        showBig(src){
            this.bigSrc = src
            this.open2 = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        cancel(){
            this.reset()
            this.open = false
            this.open2 = false
            this.openAj = false
        },
        cancel6(){
            this.open6 = false
        },
        reset(){
            this.form = {}
            this.bigSrc = ''
            this.bigSrcs = []
            this.sbSrc = ''
            this.sbSrcs = []
            this.identifyList = []
            this.identifyList2 = []
        },
        handleUpdate(row){
            this.reset()
            this.row = row
            console.log(this.row, 807)
            this.content = ''
            this.pcId = row.lsh
            this.sbFile = row.daLsh + '.pdf'
            this.loading = true
            let type = row.image ? 2 : 1
            if(row.shifoupingcha == 1){
                
                this.getMiaoshu(this.pcId,type)
            }else{
                if(row.image){
                    this.getMiaoshu(this.pcId,type,'pingcha')
                }else{
                    this.getPingcha(row)
                }
            }
            //if(this.xianqu == '仪征市'){
                //if(row.shifoupingcha == 1){
                    //this.danganJiexiYz()
                    //this.getMiaoshu(this.pcId)
                //}else{
                    //this.getPingcha(row)
                //}
            //}else{
                //if(row.shifoupingcha == 1){
                    //this.getJiexi2(this.pcId)
                    //this.getMiaoshu(this.pcId)
                //}else{
                    //this.getPingcha(row)
                //}
            //}
        },
        getImg(pcId){
            this.loading3 = true
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/process/anZhongPdfToImage`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    file:this.sbFile,
                    cmid:this.cmid,
                    pcId:pcId
                }
            })
            .then(res => {
                this.loading2 = false
                this.loading3 = false
                console.log(res)
                if(res.data.code == 0){
                    this.sbSrcs = res.data.data.imgUrl
                }else{
                    this.loading = false
                }
            })
            .catch(error => {
                this.loading3 = false
                this.loading = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '加载失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        getPingcha(row){
            console.log(row,731)
            this.loading3 = true
            this.loading4 = true
            
            let params = {
                cmid: this.cmid,
                type: 2
            };
            params.pcId = this.pcId
            console.log(this.imageList,747)
            console.log(this.sbFile, 748)
            let scType = 1
            if (this.imageList && this.imageList.length > 0) {
                params.file = '';
                params.imageList = this.imageList;
                scType = 2
            } else {
                console.log(this.sbFile, 752)
                params.file = this.sbFile;
                params.imageList = [];
                scType = 1
            }
            
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: this.baseUrl+`/process/anZhongFileOcr`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: params
            })
            .then(res => {
                this.loading3 = false
                this.loading4 = false
                console.log(res)
                if(res.data.code == 0){
                    this.getMiaoshu(this.pcId,scType)
                    if(scType == 1){
                       this.getImg(this.pcId) 
                    }
                    this.getList()
                }else{
                    this.$message.error(res.data.msg || '加载失败')
                    this.loading = false
                    this.loading3 = false
                    this.loading4 = false
                }
            })
            .catch(error => {
                this.loading3 = false
                this.loading4 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '加载失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        
        handleDelete(lsh){
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                method: 'post',
                url: this.baseUrl+`/login/delAnjiannList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    lsh:lsh
                }
            }).then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList()  
                }).catch(err => {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                })	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        handleSizeChange(val){
            this.queryParams.limit = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
    }
}
</script>


<style scoped>
.nr{position: relative;}
.beizhu{color: #ff0000;}
.shibieW{width: 100%; overflow: hidden;}
.shibie{float: left; width: calc((100% - 30px) / 2 ); height: 70vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.shibie >>> .el-scrollbar { width: 100%; height: 100%;}
.shibie >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.shibie >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.shibie >>> .el-scrollbar__view{min-height: 100%;}
.right .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.shibieW .right{float: right;}
.shibie h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.shibie ul{width: 180px;margin-right: 10px;}
.shibie ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.shibie ul li.active{color:#1890ff;}
.imgW{width: 100%;  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
.pcTk >>> .el-dialog{height: 90vh;}
.pcTk2 >>> .el-dialog{max-height: 96vh;}
.imgW >>> .el-input.is-disabled .el-input__inner,.imgW >>> .el-textarea.is-disabled .el-textarea__inner  { color: #606266;}
.shangchuan >>> .el-upload,.shangchuan >>> .el-upload-dragger {width:100%;}
/* .newTk >>> .el-loading-spinner .el-loading-text{color:#fff;}
.newTk >>> .el-loading-spinner .path{stroke: #FFF;} */
.load{position: absolute;
    z-index: 2;
    background: #fff;
    width: 100%;
    height: 100%;
    text-align: center;}
.load img{width: 40%; max-width: 240px;}
.tzbox >>> .content-container{min-width: 600px !important;height:auto !important;}
.tzbox >>> .vdr.active::before{ display: none;}

.shuoming{color:#000; padding: 0 40px 20px;}
.shuoming h2{text-align: center; line-height: 50px;}
.shuoming p{font-size: 16px; line-height: 34px; font-weight: bold;}
.content >>> .el-date-editor.el-input,.content >>> .el-date-editor.el-input__inner{width:140px;}

.anjuan{width: 100%; overflow: hidden;}
.left2{float: left; width: 300px; height: 68vh;background: #eee; border-radius: 2px; overflow-y: auto;}
.right2{float: right;width: calc(100% - 320px); height: 68vh;} 
.right2 >>> .el-textarea .el-textarea__inner{height:100%;}
.mulu{width:100%;height:calc(100% - 45px); overflow-y: auto;}
.btn{width:100%; text-align: right; margin-top: 10px;}
.left2 p {text-align: center;margin-top:10px;}

.left2 p img{width: 90%; margin:0 5%;}
.left2 p span{ width:100%; display: block; text-align: center; color: #000;}
:btnS span{cursor: pointer;}
:btnS span:hover{background:#eee;}
</style>